import { MENU } from './data';
export default function Menu() {
  return (
    <div className="bg-[#F0E4D0] text-[#3D2818] min-h-screen">
      <section className="pt-32 pb-8 max-w-[1500px] mx-auto px-8 lg:px-14 border-b-[6px] border-double border-[#3D2818]"><p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#B87333] mb-3">— The whole menu, as printed daily</p><h1 className="font-serif italic text-[44px] lg:text-[88px] leading-[0.95]">The day's bill.</h1></section>
      <section className="max-w-[1100px] mx-auto px-8 lg:px-14 py-12 space-y-12">
        {Object.entries(MENU).map(([cat, items]) => (
          <div key={cat}>
            <p className="font-serif italic text-5xl text-[#B87333] border-b-2 border-[#3D2818] pb-3 mb-6">{cat}</p>
            <ul className="space-y-4">
              {items.map(it => (
                <li key={it.code} className="grid grid-cols-[60px_1fr_120px] gap-6 items-baseline border-b border-dashed border-[#3D2818]/30 pb-3" data-testid={`bb-menu-${it.code}`}>
                  <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#B87333]">{it.code}</p>
                  <div><p className="font-serif text-xl text-[#3D2818]">{it.t}</p><p className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#3D2818]/55 mt-1">{it.d}</p></div>
                  <p className="font-serif text-2xl text-[#B87333] text-right">{it.price}</p>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </section>
    </div>
  );
}
